import { Card, CardContent, Typography, Divider, Box } from "@mui/material";
import { useLocale } from "@/middleware";
import { useTranslate } from "@/locales";

interface Order {
  id: string;
  title: string;
  deliverDate: string;
  city: string;
  address: string;
  products: Product[];
  OrderNr: number;
  status: string;
  DeliveryMethod: string;
  paymentMethod: string;
}

interface Product {
  itemId: string;
  isCanceled: boolean;
  deliveryMethod: string;
  item: string;
  quantity: number;
  price: number;
  discount: number;
  notice: string;
  image: string;
  attachment: string;
  companyId: string;
  company: {
    nameAr: string;
    CompanyNr: string;
  };
}

function InfoCard({
  calculateTotalPrice,
  order,
}: {
  order: Order;
  calculateTotalPrice: (products: Product[]) => number;
}) {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <Card
      sx={{
        height: "100%",
        borderRadius: 3,
        boxShadow: "none",
        transition: "all 0.3s ease",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: "#1a1a1a",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          📋 {t("orders.infos")}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("orders.number")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              #{order.OrderNr}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("orders.fields.deliveryDate")}:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {new Date(order.deliverDate).toLocaleDateString()}
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="body2" color="text.secondary">
              {t("orders.fields.totalPrice")}:
            </Typography>
            <Typography variant="body2" fontWeight={600} color="primary">
              {calculateTotalPrice(order.products).toFixed(2)} {t("currency")}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default InfoCard;
